import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumSmallBold,
    CustomLabelSmallMedium,
    CustomLabelSmallRegular, CustomLabelXSmallBold,
    CustomLabelXSmallRegular
} from "../common/CustomLabel";
import XMARK from "../../assets/images/xmark.png";
// import Stack from "@mui/material/Stack/Stack";
// import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
// import Box from "@mui/material/Box/Box";
// import {CustomTextField, CustomTextMultipleField} from "../common/text";
// import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
// import USER from "../../assets/images/user.png";
// import MAIL_BLACK from "../../assets/images/mail-black.png";
import ARROW_RIGHT_WITHOUT_BORDER from "../../assets/images/arrow-right-without-border.png";
import Paper from "@mui/material/Paper/Paper";
// import ON_DEMAND_LAPTOP1 from "../../assets/images/on-demand-laptaop-1.png";
// import ON_DEMAND_LAPTOP2 from "../../assets/images/on-demand-laptop-2.png";
// import ON_DEMAND_LAPTOP3 from "../../assets/images/on-demand-laptop-3.png";
// import {CustomDropdown} from "../common/CustomDrowDown";
// import CODE from "../../assets/images/code.png";
// import CLOCK_RIGHT from "../../assets/images/clock-rotate-right.png";
// import ARROR_LEFT from "../../assets/images/arrow-left.png";
// import TICK from "../../assets/images/tick.png";
import React from "react";
// import {useMediaQuery} from "@mui/material";
// import MenuItem from "@mui/material/MenuItem/MenuItem";
// import createTheme from "@mui/material/styles/createTheme";
// import SMART_PHONE from "src/assets/images/smartphone-device.png";
// import LAPTOP from "src/assets/images/laptop.png";
import CIRCLE_BLUE from "../../assets/images/check-circle.png";
import LAPTOP_DEV_MODE from "../../assets/images/laptop-dev-mode.png";
import MAIL_OUT from "../../assets/images/mail-out.png";
import BOX_ICON from "../../assets/images/3d-center-box.png";


// const theme = createTheme({
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });


const WhatServices = ({
                          setShowOnDemandDevelopers,setShowProjectByEquity,setShowFullProject,setShowWhatService
                      }) => {

    // const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


    // const steps = ['Basic Info', 'Project Requirements', 'Budget & Scope'];


    // const DeveloperStackListContainer = ["React", "Node js", "Python"].map((list) =>
    //     <MenuItem value={list}><CustomLabelSmallRegular text={list}/></MenuItem>)

    const handleClickOutside = (e) => {
        if (e.target === e.currentTarget) {
          setShowWhatService(false);
        }
      };
    return (
        <>
        <Grid 
        container 
        className="modal-overlay"
        onClick={handleClickOutside}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Grid item onClick={e => e.stopPropagation()}>
            
        <Grid container item xs={12} sm={10} md={8} lg={5.5}
              sx={{
                  position: "fixed", top: 0, right: 0, zIndex: 11, padding: {xs:"20px",md:"40px"}, background: "#FAF7FF",
                  borderRadius: "25px 0px 0px 25px", overflowY: "scroll", height: "100%"
              }}>
            <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                <Grid item xs={9}>
                    <CustomLabelMediumSmallBold text={"What service do you want?"} color={"#5E17EB"}/>
                </Grid>
                <Grid item>
                    <Grid item container justifyContent={"center"}>
                        <Grid item container
                              style={{
                                  border: "1.5px solid #DDDDDD",
                                  background: "white",
                                  borderRadius: "20px",
                                  width: "56px",
                                  height: "56px",
                                  cursor: "pointer"
                              }}
                              alignItems={"center"}
                              justifyContent={"center"}
                              onClick={(e) => setShowWhatService(false)}
                        >
                            <Grid item>
                                <img src={XMARK} alt={"XMARK"} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            <Grid item container xs={12} sx={{marginTop: "30px"}}>


                <Grid item xs={12} container justifyContent={"flex-start"}>

                    <Grid item container>
                        <Grid container justifyContent={"space-between"}>
                            <Grid item xs={12}>
                                <Paper sx={{
                                    width: "100%",
                                    background: "white",
                                    borderRadius: "25px"
                                }}>
                                    <Grid container alignItems={"flex-start"} direction={"column"}
                                          sx={{padding: "20px"}}>
                                        <Grid item>
                                            <CustomLabelXSmallBold text={"On-Demand Developers "} color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item style={{marginTop: "5px"}}>
                                            <CustomLabelSmallRegular textAlign={"left"}
                                                                     text={"No long-term commitments, no hiring headaches - just skilled developers ready to jump in."
                                                                     } color={"#A3A3A3"}/>
                                        </Grid>

                                        <Grid item container style={{marginTop: "25px"}} sx={{gap: "10px"}}>
                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Industry-leading Talent."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Instant Onboarding."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>


                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Easy Replacement."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item container sx={{
                                            border: "1.5px solid #F5F5F5",
                                            borderRadius: "20px",
                                            padding: {xs: "10px 15px", md: "15px 25px"},
                                            background: "#5E17EB", marginTop: "20px",cursor:"pointer"
                                        }}
                                              alignItems={"center"} justifyContent={"space-between"}
                                              onClick={(e) => {
                                                  setShowWhatService(false)
                                                  setShowOnDemandDevelopers(true)
                                              }}
                                        >
                                            <Grid item>
                                                <Grid container alignItems={"center"}>
                                                    <Grid item>
                                                        <img src={LAPTOP_DEV_MODE} alt={"LAPTOP DEV MODE"} />
                                                    </Grid>
                                                    <Grid item sx={{marginLeft: "10px",marginBottom:{xs:"2px",md:"0px"}}}>
                                                        <CustomLabelSmallMedium text={"Hire On Demand Developer"}
                                                                                color={"white"}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW RIGHT WITHOUT BORDER"} />
                                            </Grid>


                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>


                    <Grid item container style={{marginTop: "20px"}}>
                        <Grid container justifyContent={"space-between"}>
                            <Grid item xs={12}>
                                <Paper sx={{
                                    width: "100%",
                                    background: "white",
                                    borderRadius: "25px"
                                }}>
                                    <Grid container alignItems={"flex-start"} direction={"column"}
                                          sx={{padding: "20px"}}>
                                        <Grid item>
                                            <CustomLabelXSmallBold text={"Full Project Development "}
                                                                   color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item style={{marginTop: "5px"}}>
                                            <CustomLabelSmallRegular textAlign={"left"}
                                                                     text={"We handle everything - design, development, and deployment—so you can focus on growth."}
                                                                     color={"#A3A3A3"}/>
                                        </Grid>

                                        <Grid item container style={{marginTop: "25px"}} sx={{gap: "10px"}}>
                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE} 
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Full transparency."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Fast and reliable."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>


                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE} 
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Strong security."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item container sx={{
                                            border: "1.5px solid #F5F5F5",
                                            borderRadius: "20px",
                                            padding: {xs: "10px 15px", md: "15px 25px"},
                                            background: "#5E17EB", marginTop: "20px",cursor:"pointer"
                                        }}
                                              alignItems={"center"} justifyContent={"space-between"}
                                              onClick={(e) => {
                                                  setShowWhatService(false)
                                                  setShowFullProject(true)
                                              }}
                                        >
                                            <Grid item>
                                                <Grid container alignItems={"center"}>
                                                    <Grid item>
                                                        <img src={MAIL_OUT} alt={"MAIL OUT"} />
                                                    </Grid>
                                                    <Grid item sx={{marginLeft: "10px",marginBottom:{xs:"3px",md:"2px"}}}>
                                                        <CustomLabelSmallMedium text={"Request a Consultation"}
                                                                                color={"white"}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW RIGHT WITHOUT BORDER"} />
                                            </Grid>


                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>


                    <Grid item container style={{marginTop: "20px"}}>
                        <Grid container justifyContent={"space-between"}>
                            <Grid item xs={12}>
                                <Paper sx={{
                                    width: "100%",
                                    background: "white",
                                    borderRadius: "25px"
                                }}>
                                    <Grid container alignItems={"flex-start"} direction={"column"}
                                          sx={{padding: "20px"}}>
                                        <Grid item>
                                            <CustomLabelXSmallBold text={"Project By Equity"} color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item style={{marginTop: "5px"}}>
                                            <CustomLabelSmallRegular textAlign={"left"}
                                                                     text={"Digital Solutions at Zero upfront costs - success is shared, and expertise is guaranteed."}
                                                                     color={"#A3A3A3"}/>
                                        </Grid>

                                        <Grid item container style={{marginTop: "25px"}} sx={{gap: "10px"}}>
                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Collaboration That Pays Off."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Secure Investment."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>


                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE} 
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Top-tier experts."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                    <Grid item>
                                                        <img src={CIRCLE_BLUE}
                                                             style={{width: "16px", marginTop: "3px"}} alt={"CIRCLE BLUE"} />
                                                    </Grid>
                                                    <Grid item style={{marginLeft: "5px"}}>
                                                        <CustomLabelXSmallRegular text={"Mutual Growth."}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item container sx={{
                                            border: "1.5px solid #F5F5F5",
                                            borderRadius: "20px",
                                            padding: {xs: "10px 15px", md: "15px 25px"},
                                            background: "#5E17EB", marginTop: "20px",cursor:"pointer"
                                        }}
                                              alignItems={"center"} justifyContent={"space-between"}
                                              onClick={(e) => {
                                                  setShowWhatService(false)
                                                  setShowProjectByEquity(true)
                                              }}
                                        >
                                            <Grid item>
                                                <Grid container alignItems={"center"}>
                                                    <Grid item>
                                                        <img src={BOX_ICON} alt={"BOX ICON"} />
                                                    </Grid>
                                                    <Grid item sx={{marginLeft: "10px",marginBottom:{xs:"2px",md:"2px"}}}>
                                                        <CustomLabelSmallMedium text={"Discuss Your Project"}
                                                                                color={"white"}/>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW RIGHT WITHOUT BORDER"} />
                                            </Grid>


                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>


            </Grid>

        </Grid>
        </Grid>
        </Grid>
        </>
    )
}


export default WhatServices;
